// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"9467706b","559":"bdc7af24","803":"8547490a","907":"c0bde9f6"}[chunkId] + ".chunk.js";
};